/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Minimize",
  size: 20
}

const SvgMinimize = ({ size, ...props }: Props) => (
  <Svg
    viewBox="0 0 20 20"
    height={size}
    width={size}
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <g fill="none">
      <path d="M2 18h16" strokeWidth={1.1} />
      <path d="M0 0h20v20H0z" />
    </g>
  </Svg>
)

SvgMinimize.defaultProps = defaultProps
export default SvgMinimize
